import { Link, useParams } from "react-router-dom";
import { Icon } from "../../app/Icon";
import { BlogBreadcrumbs, BlogCover, BlogCta, BlogLayout } from "./BlogLayout";
import { blogPosts, formatPostDate } from "./posts";

export default function BlogArticlePage() {
  const { slug } = useParams();
  const post = blogPosts.find(post => post.slug === slug);

  if (!post) return <BlogLayout path="/blog/not-found">
    <main id="blog-main" className="blog-not-found landing-wrap" tabIndex={-1}>
      <p className="blog-eyebrow">THE BLOG</p>
      <h1>This page is a <em>blank canvas.</em></h1>
      <p>We couldn’t find that article. Find your next read on the blog.</p>
      <Link className="blog-back" to="/blog"><Icon name="arrow-left" />All articles</Link>
    </main>
  </BlogLayout>;

  return <BlogLayout path={`/blog/${post.slug}`}>
    <main id="blog-main" className="blog-article-layout landing-wrap" tabIndex={-1}>
      <nav className="blog-article-nav" aria-label="Blog navigation"><Link className="blog-back" to="/blog"><Icon name="arrow-left" />All articles</Link></nav>
      <article className="blog-article">
        <BlogBreadcrumbs post={post} />
        <header className="blog-article__header">
          <p className="blog-category">{post.category}</p>
          <h1>{post.title}</h1>
          <div className="blog-byline"><time dateTime={post.publishedAt}>{formatPostDate(post.publishedAt)}</time><span>By {post.author}</span><span>{post.readingMinutes} min read</span>{post.updatedAt && <span>Updated <time dateTime={post.updatedAt}>{formatPostDate(post.updatedAt)}</time></span>}</div>
          <p className="blog-article__intro">{post.excerpt}</p>
        </header>
        <BlogCta />
        <figure className="blog-article__cover"><BlogCover cover={post.cover} /><figcaption>{post.cover.caption}</figcaption></figure>
        {post.sections.length > 3 && <nav className="blog-contents" aria-labelledby="blog-contents-title">
          <h2 id="blog-contents-title">On this page</h2>
          <ol>{post.sections.map(section => <li key={section.id}><a href={`#${section.id}`}>{section.title}</a></li>)}</ol>
        </nav>}
        <div className="blog-prose">
          {post.sections.map(section => <section id={section.id} key={section.id}><h2>{section.title}</h2>{section.content}</section>)}
          {post.faq && post.faq.length > 0 && <section id="faq" className="blog-faq" aria-labelledby="blog-faq-title"><h2 id="blog-faq-title">Frequently asked questions</h2>{post.faq.map(faq => <details key={faq.question}><summary>{faq.question}<Icon name="plus" /></summary><p>{faq.answer}</p></details>)}</section>}
          {post.sources.length > 0 && <section className="blog-sources" aria-labelledby="blog-sources-title"><h2 id="blog-sources-title">Sources</h2><ul>{post.sources.map(source => <li key={source.href}><a href={source.href}>{source.title}<Icon name="arrow-right" /></a><p>{source.note}</p></li>)}</ul></section>}
        </div>
        <div className="blog-article__end"><Link className="blog-back" to="/blog"><Icon name="arrow-left" />All articles</Link><span>Thanks for reading.</span></div>
      </article>
    </main>
  </BlogLayout>;
}
